import { Controller } from '@hotwired/stimulus';
import { useWindowResize } from 'stimulus-use';

export default class extends Controller {
    static targets = ['notification', 'notificationBadge', 'oriBadge'];

    static outlets = ['header--navigation', 'header--mobile'];

    connect() {
        useWindowResize(this);
    }

    windowResize() {
        document.body.style.setProperty('--header-height', `${this.element.getBoundingClientRect().height}px`);

        this.navigationToggled();
    }

    navigationToggled() {
        const hasNavigationItemOpen = this.hasHeaderNavigationOutlet && this.headerNavigationOutlets.some((element) => element.openValue);
        const hasHeaderMobileOpen = this.hasHeaderMobileOutlet && this.headerMobileOutlet.menuOpenValue;

        const shouldOverflowHidden = hasNavigationItemOpen || hasHeaderMobileOpen;

        document.body.classList.toggle('hide-header-overflow', shouldOverflowHidden);

        document.getElementById('header-overlay')?.classList.toggle('tw-hidden', !hasNavigationItemOpen);
    }

    hide() {
        this.headerNavigationOutlets.forEach((outlet) => {
            outlet.hide();
            outlet.closeNestedMenus();
        });

        this.headerMobileOutlet.hide();
    }

    loadNotifications() {
        const user = JSON.parse(sessionStorage.getItem('user'));
        if (!user?.content?.connected) {
            if (this.hasNotificationTarget) {
                this.notificationTarget.classList.add('tw-hidden');
            }

            if (this.hasNotificationBadgeTarget) {
                this.notificationBadgeTarget.classList.add('tw-hidden');
            }

            return;
        }

        if (this.hasOriBadgeTarget) {
            this.oriBadgeTarget.classList.add('tw-hidden');
        }

        this.notificationTarget.classList.remove('tw-hidden');
    }

    showNotificationBadge() {
        if (this.hasNotificationBadgeTarget) {
            this.notificationBadgeTarget.classList.remove('tw-hidden');
        }
    }

    hideNotificationBadge() {
        if (this.hasNotificationBadgeTarget) {
            this.notificationBadgeTarget.classList.add('tw-hidden');
        }
    }
}
